// prism global CSS
require('prismjs/themes/prism.css')
// Prism enable line-numbers
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
